import React, { Component } from "react";
import AdSense from "react-adsense";
export default class test extends Component {
  render() {
    return (
      <div>
        <h1>sds</h1>
        <AdSense.Google
          client="ca-pub-4962161032290010"
          slot="5485465746"
          height={200}
        />
      </div>
    );
  }
}
